module.exports = __webpack_public_path__ + "static/media/vbn-custom-1.fcab86c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/VBN/vbn-custom-1.png
// module id = 208
// module chunks = 0